import { defer, toInteger } from "lodash";
import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { TFLocationState } from "types/topicflow";

import { meetingsRoutes } from "@apps/main/routes-constants";
import { meetingLeftSidePanelDisplayedVar } from "@cache/cache";
import { useLink } from "@components/link/link-helpers";

const MeetingsRoutes = () => {
  const location = useLocation<TFLocationState>();
  const link = useLink();

  useEffect(() => {
    const matchedPath = meetingsRoutes
      .map((route) => {
        return matchPath(location.pathname, {
          path: route,
          exact: true, // or false if you want partial matches
          strict: false,
        });
      })
      .find(Boolean);

    if (
      matchedPath &&
      matchedPath.params &&
      "userId" in matchedPath.params &&
      "type" in matchedPath.params
    ) {
      const type = matchedPath.params.type;
      const userId = toInteger(matchedPath.params.userId);
      if ((type === "1on1" || type === "group") && userId) {
        meetingLeftSidePanelDisplayedVar({ type, userId });
      } else {
        meetingLeftSidePanelDisplayedVar(true);
      }
    } else {
      meetingLeftSidePanelDisplayedVar(true);
    }
    defer(() => {
      link.redirect("/");
    });
  }, []);
  return null;
};

export default MeetingsRoutes;
